import { render } from "./ley.vue?vue&type=template&id=1044b842&scoped=true"
import script from "./ley.vue?vue&type=script&lang=js"
export * from "./ley.vue?vue&type=script&lang=js"

import "./ley.vue?vue&type=style&index=0&id=1044b842&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1044b842"]])

export default __exports__